import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useConfig() {
  const [config, setConfig] = useState({ prospectus_url: "", sample_material_url: "", calendar_url: "", analytics_id: "" });
  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/config`)
      .then((r) => mounted && setConfig(r.data))
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);
  return config;
}

export function getUTMParams() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    utm_content: p.get("utm_content") || "",
    referring_url: document.referrer || "",
  };
}

export { API };
